import React from 'react';
import { __ } from 'i18n-for-browser';
import connect from "react-redux/es/connect/connect";

import actions from '../../actions';
import { icons } from '../../assets/assets';
import ContentContainer from '../elements/ContentContainer';
import {
  getIcon,
  getImage,
  getTitle,
  getProbleemTekst,
  getOplossingen,
  getSolutionByCode
} from '../../helpers/policyChoiceHelper';
import GoBackButton from "./GoBackButton";

import config from '../../config';

const { updateMyState } = actions.gameStateInput;

export default connect(state => ({
  policyChoice: state.policyChoice,
  gameState: state.gameState,
  gameStateInput: state.gameStateInput,
  user: state.user,
}))(class PolicyChoiceLaag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  componentWillReceiveProps(props) {
    if (this.state.show !== props.show) {
      this.setState({ show: props.show });
    }
  }

  toggleShow = (el) => {
    if (this.props.onClick) {
      this.props.onClick();
      return;
    }
    if (!this.props.mainView) {
      this.setState({show: !this.state.show});
      // el.target.scrollIntoView({behavior: 'smooth'});
    }
  }

  chooseSolution = (ev) => {
    ev.stopPropagation();
    const target = ev.currentTarget.getElementsByTagName('input')[0];
    const { dispatch, gameStateInput } = this.props;
    const policyChoices = gameStateInput.myState.policyChoices;
    const prevMade = getSolutionByCode(policyChoices[target.name], this.props.policyChoice);
    const prevMadeCosts = prevMade.kosten || 0;
    const newChoice = getSolutionByCode(target.value, this.props.policyChoice);
    const newCosts = newChoice.kosten || 0;
    if (((this.props.spendableGlobas + prevMadeCosts) - newCosts) >= 0 || newCosts === 0) {
      dispatch(updateMyState({ policyChoices: { ...policyChoices, [target.name]: target.value } }));
    }
  }

  render() {
    const { props } = this;
    const { policyChoice, gameState, problem, gameStateInput } = props;
    const solutions = getOplossingen(policyChoice, problem.Nummer, gameState.language);
    if (!gameStateInput || !policyChoice || !gameState || !problem) return null;
    const solution = getSolutionByCode(gameStateInput.myState.policyChoices[problem.Nummer], policyChoice, gameState.language) || { kosten: 0 };
    let costs = '-';
    let title = getTitle(problem, gameState.language);
    if (gameStateInput.myState.policyChoices[problem.Nummer]) {
      title = solution.titel;
      costs = solution.kosten;
    }

    if ((this.props.mainView && this.props.setShow) || !this.props.mainView) {
      if (this.props.mainView) {
        return (
          <div className={'darkBckg'}>
            <div className={'policy-choice'}>
              <div className={`content${(this.state.show || this.props.setShow ? ' show' : '')}`}>
                <div className="title-block">
                  <img alt="icon" src={getIcon(problem)}/>

                  <h4>{title}</h4>

                  <span className={'point-holder'}>
                    <span title={costs}>{costs}</span>
                    <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                  </span>

                  <GoBackButton history={this.props.history}/>
                </div>

                <div className="problem-description">
                  <h3>{__('sim_probleem')}</h3>

                  <div className={'problem-wrapper'}>
                    <div className={'problem-img-wrapper'}>
                      <img src={`${config.mediaUrl}${getImage(problem, gameState.language)}.jpeg`} alt="problem"/>
                    </div>

                    <ContentContainer>
                      <p>{getProbleemTekst(problem, gameState.language)}</p>
                    </ContentContainer>
                  </div>
                </div>

                <div className='solutions'>
                  <h3>{__('sim_kies_oplossing')}</h3>

                  <div className={'flex-solutions'}>
                  {solutions.map((oplossing, i) => (
                    <div onClick={this.chooseSolution} className={'solution' + (gameStateInput.myState.policyChoices[problem.Nummer] === oplossing.id ? ' checked' : '') + (this.props.user.role === 'groupmember' ? ' groupmember-disabled' : '')} key={i}>
                      <ContentContainer>
                        <div className={'radio-container'}>
                          <input
                            onChange={() => {
                            }}
                            type="radio"
                            name={problem.Nummer}
                            value={oplossing.id}
                            checked={gameStateInput.myState.policyChoices[problem.Nummer] === oplossing.id}
                          />
                          <span></span>
                        </div>

                        <p>{oplossing.tekst}</p>

                        <div className='costs'>
                          <div className='inner-costs'>
                            <img src={icons.globas} alt={'globas'}/>

                            <div className='costs-price'>
                              <span title={oplossing.kosten}>{oplossing.kosten}</span>
                              <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                            </div>
                          </div>
                        </div>
                      </ContentContainer>
                    </div>
                  ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        let contentContainerClasses = `policy-choice${(gameStateInput.myState.policyChoices[problem.Nummer] ? ' checked' : '')}${((this.state.show && !this.props.listView) || (this.props.setShow && !this.props.listView) ? ' show' : '')}`;
        if (this.props.highlight && this.props.listView) {
          contentContainerClasses += ' highlight';
        }
        return (
          <ContentContainer
            onClick={this.toggleShow}
            className={contentContainerClasses}>
            {!this.props.mainView ?
              <div className="top-bar">
                <img className="icon" alt="ico" src={getIcon(problem)}/>
                <img className="icon check" alt="check" src={icons.check}/>
                <h4 className="title">{title}</h4>
                <div className={'point-holder'}>
                  <li>
                    <span title={costs}>{costs}</span>
                    <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                  </li>
                </div>
              </div>
             : null}
            {!this.props.listView ?
              <div className={`content${(this.state.show || this.props.setShow ? ' show' : '')}`}>
                <div className="problem-description mobile">
                  <img src={`${config.mediaUrl}${getImage(problem, gameState.language)}.jpeg`} alt="problem"/>

                  <h4>{__('sim_probleem')}</h4>
                  <p>{getProbleemTekst(problem, gameState.language)}</p>
                </div>
                <div className="solutions">
                  <h4>{__('sim_kies_oplossing')}</h4>
                  {solutions.map((oplossing, i) => (
                    <div onClick={this.chooseSolution} className={'solution' + (this.props.user.role === 'groupmember' ? ' groupmember-disabled' : '')} key={i}>
                      <div className={'radio-container'}>
                        <input
                          onChange={() => {
                          }}
                          type="radio"
                          name={problem.Nummer}
                          value={oplossing.id}
                          checked={gameStateInput.myState.policyChoices[problem.Nummer] === oplossing.id}
                        />
                        <span></span>
                      </div>

                      <p>{oplossing.tekst}</p>

                      <div className="costs">
                        <span title={oplossing.kosten}>{oplossing.kosten}</span>
                        <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div> : ''
            }
          </ContentContainer>
        );
      }
    } else {
      return (<div/>);
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/elements/PolicyChoiceLaag.js